import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";
import { logOut } from './../util'

export default function BulkEditRedirectUrlDialog({
    token,
    setToken,
    open,
    setOpen,
    handleCloseExternal,
    apiEndpoint,
    update,
    setState,
    dialogTitle,
    dbFieldname,
    inputLabel,
    placeholderText,
    entityIds,
    accountId,
    responseDataKey // Helps get just a specific key out of the response. Schedule responses, for example, contain a forbidden key and a schedule key
}) {
    const [input, setInput] = useState(update ? update[dbFieldname] : '')
    let navigate = useNavigate()

    function handleClose(event) {
        setOpen(false)
        handleCloseExternal();
        setInput("")
    }

    const handleInputChange = (event) => {
        setInput(event.target.value);
        event.preventDefault();
    };

    const handleKeyPress = event => {
        if (event.key === 'Enter') {
            handleSubmit(event)
            event.preventDefault();
        }
    }

    useEffect(() => {
        if (update)
            return setInput(update[dbFieldname] ?? '')
    }, [update])

    function handleSubmit(event) {
        let status;

        let body = {
            ...update,
            [dbFieldname]: input === '' ? null : input,
            accountId: accountId,
            ids: entityIds
        }

        fetch(apiEndpoint, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify(body)
        })
            .then(response => {
                status = response.status;
                return response.json();
            })
            .then(json => {

                if (status !== 200) {
                    if (status === 401) {
                        return logOut({ navigate, setToken })
                    }
                    if (update)
                        setInput(update[dbFieldname] ?? '')
                    return alert(json.message)
                }

                setState(state => {
                    let newState = JSON.parse(JSON.stringify(state))

                    return newState.map(item => {
                        if (entityIds.includes(item._id)) {
                            return { ...item, [dbFieldname]: body[dbFieldname] }
                        }
                        return item
                    })
                });
            })
            .catch(err => {
                console.log(err)
            })
        handleClose()
        event.preventDefault();
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth >
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    update={input}
                    margin="dense"
                    id={inputLabel}
                    label={inputLabel}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress}
                    placeholder={placeholderText}
                    autoComplete='off'
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
